// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api.s.recruitee.com/',
  authUrl: 'https://auth.s.recruitee.com/',
  webAppUrl: 'https://app.s.recruitee.com/',
  appUrl: 'https://s.recruitee.com/',
  hasHttps: true,
  isE2e: !!window.Cypress,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
